import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
	<div className="fullpage notfound col-lg-12 d-flex justify-content-center align-items-center">
		<div className="d-flex flex-column align-items-center">
			<h1 className="fourofour">404</h1>
			<h2>Sidan hittades inte :(</h2>
			<p>Klicka <Link className="click" to="/">här</Link> för att komma till startsidan</p>
		</div>
	</div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js